import { render, staticRenderFns } from "./PageVideo.vue?vue&type=template&id=ac94b77e&scoped=true"
import script from "./PageVideo.vue?vue&type=script&lang=js"
export * from "./PageVideo.vue?vue&type=script&lang=js"
import style0 from "./PageVideo.vue?vue&type=style&index=0&id=ac94b77e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac94b77e",
  null
  
)

export default component.exports